import React, { useEffect } from 'react'

import { useRouter } from 'next/router'

import { useEnrollments } from '@dentalux/security'

import {
  setOfferRememberDevice,
  useUnauthorizedContext,
  useUnauthorizedDispatch,
} from 'src/components/providers/UnauthorizedProvider'
import { useRedirectUrlHandling } from 'src/hooks/useRedirectUrlHandling'
import { RegistrationScreen } from 'src/screens/Registration/Registration'
import withTranslation from 'src/staticProps/withTranslation'

const RegistrationPage = () => {
  const router = useRouter()

  useRedirectUrlHandling({ shouldRead: true })

  const unauthorizedDispatch = useUnauthorizedDispatch()
  const { preferredLanguageCode, shouldSyncLanguage } = useUnauthorizedContext()

  const { submit, isLoading } = useEnrollments({
    onSuccess: () => {
      unauthorizedDispatch(setOfferRememberDevice(false))
    },
  })

  useEffect(() => {
    router.prefetch('/verifyphone')
  }, [])

  return (
    <RegistrationScreen
      onSubmit={(data) =>
        submit({
          ...(shouldSyncLanguage && { preferredLanguageCode }),
          patientRegistrationSource: 'HEALTH_ASSISTANT',
          ...data,
        })
      }
      processing={isLoading}
    />
  )
}

export const getStaticProps = withTranslation

export default RegistrationPage
